export default __webpack_public_path__ + "static/media/users.e9c8bd9f.svg";